import { Dialog } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {ReactComponent as CrossIcon} from "assets/img/svg/CrossIcon.svg"
import "./style.scss";
import { fetchAllPostPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { fetchAllPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { endpoint, pages } from '../../../common/constant';
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { gridComponents } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import moment from "moment";
import { Tooltip } from "@mui/material";
import NoRowOverlay from "views/pages/manage/masters/holidayMaster/NoRowOverlay";
import ALoader from 'views/pages/manage/common/a-loader';
const LocationHistory=({
    isOpen,
    setOpen,
    buId})=>{

const [loader,setLoader] = useState(false)
const [rowData,setRowData] = useState([{}])

useEffect(()=>{
buId&&getLocationHistory()
},[buId])

const getLocationHistory=async()=>{

    try{
        setLoader(true)
        const url = `${endpoint.audit.locationDetail}/${buId}`
        const data = await fetchAllPromisedData(url)
        setRowData(data?.locationDetailsAudDtoList??[
            {
                "id": 2,
                "rev": 2519,
                "revType": 1,
                "buildingName": "Delhi-Janak Puri Branch",
                "businessAreaId": 11,
                "status": null,
                "country": "INDIA",
                "address1": "A-1/26, Janakpuri",
                "address2": "delhi",
                "address3": "Head Branch for testing",
                "address4": "Delhi",
                "pincode": "110058",
                "city": "New Delhi",
                "district": "New Delhi",
                "state": "Delhi",
                "isDeleted": false,
                "landmark": "NA",
                "latitude": "",
                "longitude": "",
                "googleMapLink": "",
                "createdBy": "AESL-A14128",
                "createdOn": "2024-08-07T09:43:25.000+00:00",
                "updatedBy": "AESL-A16458",
                "updatedOn": "2025-05-22T10:43:28.000+00:00"
            },
            {
                "id": 2,
                "rev": 2518,
                "revType": 1,
                "buildingName": "Delhi-Janak Puri Branch",
                "businessAreaId": 11,
                "status": null,
                "country": "INDIA",
                "address1": "A-1/26, Janakpuri",
                "address2": "delhi",
                "address3": "Head Branch for testing",
                "address4": "Delhi",
                "pincode": "110058",
                "city": "New Delhi",
                "district": "New Delhi",
                "state": "Delhi",
                "isDeleted": false,
                "landmark": "NA",
                "latitude": "",
                "longitude": "",
                "googleMapLink": "",
                "createdBy": "AESL-A14128",
                "createdOn": "2024-08-07T09:43:25.000+00:00",
                "updatedBy": "AESL-A16458",
                "updatedOn": "2025-05-22T10:43:25.000+00:00"
            }
        ])
    }
    catch(err){
       console.log(err)
    }
    finally{
        setLoader(false)
    }
}
const columns=[
    new AGridColDef("updatedOn", "Date", false)
            .setMinWidth(100)
            .editable(true)
            .setFlex(2)
            .renderCellComponent((params) => (
              params?.value ? <Tooltip title={moment(params?.value).format('DD/MM/YYYY')}>
                <div className={`ellipsis-text-container`}>{moment(params?.value).format('DD/MM/YYYY')}</div>
              </Tooltip> : <div>-</div>
            )),
            new AGridColDef("address1", "New Address", false)
            .setMinWidth(100)
            .editable(true)
            .setFlex(2)
            .renderCellComponent((params) => (
              params?.value ? <Tooltip title={`${params?.value} ${params?.row.address2} ${params?.row.address3} ${params?.row.address4} ${params?.row.city} ${params?.row.district} ${params?.row.state} ${params?.row.pincode}`}>
                <div className={`ellipsis-text-container`} >{`${params?.value} ${params?.row.address2&&params?.row.address2} ${params?.row.address3 && params?.row.address3} ${params?.row.address4&&params?.row.address4} ${params?.row.city} ${params?.row.district} ${params?.row.state} ${params?.row.pincode}`}</div>
              </Tooltip> : <div>-</div>
            )),
            new AGridColDef("updatedBy", "Last updated by", false)
            .setMinWidth(100)
            .editable(true)
            .setFlex(2)
            .renderCellComponent((params) => (
              params?.value ? <Tooltip title={`${moment(params?.row?.updatedOn).format('DD-MM-YYYY')} ${moment(params?.row?.updatedOn).format('hh:mm A')},  by ${params?.value}`}>
                <div className={`ellipsis-text-container`} >{`${moment(params?.row?.updatedOn).format('DD-MM-YYYY')} ${moment(params?.row?.updatedOn).format('hh:mm A')},  by ${params?.value}`}</div>
              </Tooltip> : <div>-</div>
            )),
           
]
    return(
    <Dialog
        open={isOpen}
        PaperProps={{ sx: { maxWidth: "unset", borderRadius: "12px" } }}
      >
        <div className="select-concession-popup">
          <div className="d-flex " style={{ justifyContent: "space-between" }}>
            {loader&& <ALoader/>}
            <div className="heading-4 color-dark" >Location history </div>
            <CrossIcon onClick={()=>setOpen(false)}/>

            </div>
            <div className="" style={{border:'1px solid #EEE', borderRadius:'8px'}}>
                    <ADataGrid
                      removeWrapperContainer
                      rowModesModel
                      rows={rowData || []}
                      columns={columns}
                      rowId={(row) =>JSON.stringify(row)}
                      rowHeight={50}
                      rowCount={rowData.length}
                      loading={false}
                      components={{
                        ...gridComponents,
                        NoRowsOverlay: () => (
                          <NoRowOverlay message={loader ? "Loading..." : null} />
                        ),
                      }}
                      sx={{
                        ...gridStyles,
                      }}
                      autoHeight
                      hidePagination={true}
                    />
                  </div>
            {/* <ListComponent loader={loader} rows={jodoHistoryData} /> */}
    </div>
    </Dialog>
    )
}
export default LocationHistory;